import script from "./TextFloatImageDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextFloatImageDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./TextFloatImageDisplay.vue?vue&type=style&index=0&id=3b32b5d3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b32b5d3"]])

export default __exports__